<template>
  <div class="orderBox">
    <div class="form-title">保单信息</div>
    <FormItem prop="companyId" label="保险公司" :rules="$units.formRule.required('请选择')">
      <span v-if="disabled">{{ formData.companyId | filterVal(companyList, 'id', 'name') }}</span>
      <Select v-else v-model="formData.companyId" filterable transfer clearable @on-change="companyChange">
        <Option v-for="item in companyList" :value="item.id" :key="item.id">{{ item.name }}</Option>
      </Select>
    </FormItem>

    <FormItem prop="productId" label="保险产品" :rules="$units.formRule.required('请选择')">
      <span v-if="disabled">{{ formData.productId | filterVal(productList, 'id', 'name') }}</span>
      <Select v-else v-model="formData.productId" filterable transfer clearable @on-change="onSelectProduct">
        <Option v-for="item in productList" :value="item.id" :key="item.id">{{ item.name }}</Option>
      </Select>
    </FormItem>

    <FormItem prop="policyNo" label="保单编号" :rules="$units.formRule.required('请输入')">
      <span v-if="disabled" class="descrypt-text" @dblclick="openEye(formData, 'policyNo')">{{ formData.policyNo }}</span>
      <Input v-else type="text" v-model="formData.policyNo" placeholder="请输入" />
      <a v-if="$parent.disabled && formData.policyNo" style="color: #2d8cf0 !important">
        <i class="iconfont iconyincang eye-icon eye" v-if="!formData.eyeShowpolicyNo" @click="openEye(formData, 'policyNo')"></i>
      </a>
    </FormItem>

    <FormItem prop="paymentPeriod" label="缴费期" :rules="paymentPeriodRules">
      <span v-if="disabled">{{ formData.paymentPeriod }}</span>
      <Input v-else v-model="formData.paymentPeriod" placeholder="请输入" @on-blur="onNumberInput('paymentPeriod')"> </Input>
    </FormItem>
    <FormItem prop="paymentType" label="缴费类型" :rules="disabled ? {} : $units.formRule.required('请选择')">
      <lzDicTxt v-if="disabled" dicType="GUARANTEE_TYPE" :dicCode="formData.paymentType"></lzDicTxt>
      <lzDicSelect v-else v-model="formData.paymentType" dicType="GUARANTEE_TYPE" :transfer="true" clearable placeholder="请选择"> </lzDicSelect>
    </FormItem>
    <FormItem prop="guaranteePeriod" label="保障期" :rules="guaranteePeriodRules">
      <span v-if="disabled">{{ formData.guaranteePeriod }}</span>
      <Input v-else v-model="formData.guaranteePeriod" placeholder="请输入" @on-blur="onNumberInput('guaranteePeriod')"> </Input>
    </FormItem>
    <FormItem prop="guaranteeType" label="保障类型" :rules="disabled ? {} : $units.formRule.required('请选择')">
      <lzDicTxt v-if="disabled" dicType="GUARANTEE_TYPE" :dicCode="formData.guaranteeType"></lzDicTxt>
      <lzDicSelect v-else v-model="formData.guaranteeType" dicType="GUARANTEE_TYPE" :transfer="true" clearable placeholder="请选择"> </lzDicSelect>
    </FormItem>

    <FormItem prop="fee" label="年缴保费" :rules="$units.formRule.required('请输入')">
      <span v-if="disabled">{{ formData.fee }}</span>
      <Input v-else type="text" v-model="formData.fee" placeholder="请输入" />
    </FormItem>

    <FormItem prop="currencyType" label="货币种类" :rules="$units.formRule.required('请选择')">
      <lzDicTxt v-if="disabled" :dicCode="formData.currencyType" dicType="CURRENCY_TYPE"></lzDicTxt>
      <lzDicSelect v-else v-model="formData.currencyType" dicType="CURRENCY_TYPE" :transfer="true" clearable />
    </FormItem>

    <FormItem prop="coverage" label="保险额度">
      <span v-if="disabled">{{ formData.coverage }}</span>
      <Input v-else type="text" v-model="formData.coverage" placeholder="请输入" />
    </FormItem>

    <FormItem prop="firstPaymentMethod" label="首期付款方式">
      <lzDicTxt v-if="disabled" :dicCode="formData.firstPaymentMethod" dicType="FIRST_PAY_TYPE"></lzDicTxt>
      <lzDicSelect v-else v-model="formData.firstPaymentMethod" dicType="FIRST_PAY_TYPE" :transfer="true" clearable />
    </FormItem>

    <FormItem prop="isTraceSource" label="是否溯源">
      <lzDicTxt v-if="disabled" :dicCode="formData.isTraceSource" dicType="YES_NO"></lzDicTxt>
      <lzDicSelect v-else v-model="formData.isTraceSource" dicType="YES_NO" :transfer="true" clearable />
    </FormItem>

    <FormItem prop="bank" label="开户银行">
      <lzDicTxt v-if="disabled" :dicCode="formData.bank" dicType="BANK_TYPE"></lzDicTxt>
      <lzDicSelect v-else v-model="formData.bank" dicType="BANK_TYPE" :transfer="true" clearable />
    </FormItem>

    <FormItem prop="bankCardNo" label="银行卡号">
      <span v-if="disabled" class="descrypt-text" @dblclick="openEye(formData, 'bankCardNo')">{{ formData.bankCardNo }}</span>
      <Input v-else type="text" v-model="formData.bankCardNo" placeholder="请输入" />
      <a v-if="$parent.disabled && formData.bankCardNo" style="color: #2d8cf0 !important">
        <i class="iconfont iconyincang eye-icon eye" v-if="!formData.eyeShowbankCardNo" @click="openEye(formData, 'bankCardNo')"></i>
      </a>
    </FormItem>

    <FormItem prop="productType" label="产品类型">
      <lzDicTxt v-if="disabled" :dicCode="formData.productType" dicType="PRODUCT_TYPE2"></lzDicTxt>
      <Select v-else v-model="formData.productType" filterable transfer clearable>
        <Option v-for="(txt, value) in themeList" :value="value" :key="value">{{ txt }}</Option>
      </Select>
    </FormItem>

    <FormItem prop="status" label="保单状态" :rules="$units.formRule.required('请选择')">
      <policyStatusTxt v-if="parent.mode === 'edit' || isRead" :formData="formData" />
      <policyStatusSelect v-else v-model="formData._status" :valExcludes="['6']" @on-change="onChangeStatus" />
    </FormItem>

    <FormItem prop="signDate" label="签单日期" :rules="$units.formRule.objRequired('请选择')">
      <span v-if="disabled">{{ formData.signDate | cutString(10) }}</span>
      <DatePicker v-else type="date" format="yyyy-MM-dd" placeholder="请选择" v-model="formData.signDate"></DatePicker>
    </FormItem>

    <FormItem v-if="['5', '2', '3_301', '3_302', '4', '1', '1_101', '1_102', '-1', '6'].includes(formData._status)" prop="policySubmitDate" label="交单日期">
      <span v-if="disabled">{{ formData.policySubmitDate | cutString(10) }}</span>
      <DatePicker v-else type="date" format="yyyy-MM-dd" placeholder="请选择" v-model="formData.policySubmitDate"></DatePicker>
    </FormItem>

    <FormItem v-if="['3_301', '3_302'].includes(formData._status)" prop="pendingDate" label="pending下发日期">
      <span v-if="disabled">{{ formData.pendingDate | cutString(10) }}</span>
      <DatePicker v-else type="date" format="yyyy-MM-dd" placeholder="请选择" v-model="formData.pendingDate"></DatePicker>
    </FormItem>

    <FormItem v-if="['3_302'].includes(formData._status)" prop="pendingHandleDate" label="pending处理日期">
      <span v-if="disabled">{{ formData.pendingHandleDate | cutString(10) }}</span>
      <DatePicker v-else type="date" format="yyyy-MM-dd" placeholder="请选择" v-model="formData.pendingHandleDate"></DatePicker>
    </FormItem>

    <FormItem v-if="['0'].includes(formData._status)" prop="cancelDate" label="取消投保日期">
      <span v-if="disabled">{{ formData.cancelDate | cutString(10) }}</span>
      <DatePicker v-else type="date" format="yyyy-MM-dd" placeholder="请选择" v-model="formData.cancelDate"></DatePicker>
    </FormItem>

    <FormItem v-if="['4', '1', '1_101', '1_102', '-1'].includes(formData._status)" prop="underwriteTime" label="核保通过日期">
      <span v-if="disabled">{{ formData.underwriteTime | cutString(10) }}</span>
      <DatePicker v-else type="date" format="yyyy-MM-dd" placeholder="请选择" v-model="formData.underwriteTime"></DatePicker>
    </FormItem>

    <FormItem
      v-if="['1', '1_101', '1_102', '-1', '6'].includes(formData._status)"
      prop="effectDate"
      label="生效日期"
      :rules="$units.formRule.objRequired('请选择')"
    >
      <span v-if="disabled">{{ formData.effectDate | cutString(10) }}</span>
      <DatePicker v-else type="date" format="yyyy-MM-dd" placeholder="请选择" v-model="formData.effectDate"></DatePicker>
    </FormItem>

    <FormItem
      v-if="['1', '1_101', '1_102', '-1', '6'].includes(formData._status)"
      prop="expirationDate"
      label="冷静期截止日"
      :rules="$units.formRule.objRequired('请选择')"
    >
      <span v-if="disabled">{{ formData.expirationDate | cutString(10) }}</span>
      <DatePicker v-else type="date" format="yyyy-MM-dd" placeholder="请选择" v-model="formData.expirationDate"></DatePicker>
    </FormItem>

    <FormItem v-if="['-1'].includes(formData._status)" label="退保日期">
      <span v-if="disabled">{{ formData.refundDate | cutString(10) }}</span>
      <DatePicker
        v-else
        type="date"
        format="yyyy-MM-dd"
        placeholder="请选择"
        :editable="false"
        :value="formData.refundDate"
        @on-change="$set(formData, 'refundDate', $event)"
      ></DatePicker>
    </FormItem>

    <FormItem v-if="['-1', '1', '1_101', '1_102', '6'].includes(formData._status)" prop="expireDate" label="最新保费到期日">
      <span v-if="disabled">{{ formData.expireDate | cutString(10) }}</span>
      <DatePicker v-else type="date" format="yyyy-MM-dd" v-model="formData.expireDate" disabled></DatePicker>
    </FormItem>
    <FormItem v-if="['6'].includes(formData._status)" prop="endDate" label="终止日期">
      <span v-if="parent.mode === 'edit' || isRead">{{ formData.endDate | cutString(10) }}</span>
      <DatePicker v-else type="date" format="yyyy-MM-dd" v-model="formData.endDate" disabled></DatePicker>
    </FormItem>

    <FormItem :label-width='130' label="是否为专业投资者" prop="isInvestor" :rules="$units.formRule.required('请选择是否为专业投资者')">
      <span v-if="parent.mode === 'edit' || isRead">{{ formData.isInvestor | filterYesOrNo }}</span>
      <RadioGroup v-else v-model="formData.isInvestor">
        <Radio label="1">是</Radio>
        <Radio label="0">否</Radio>
      </RadioGroup>
    </FormItem>

    <FormItem v-if="isTransfer" label="是否添加附加险" prop="isAdditional">
      <span>{{ formData.isAdditional | filterYesOrNo }}</span>
    </FormItem>
    <template v-if="isTransfer && formData.isAdditional == 1">
      <div style="margin-top: 10px" class="form-title">附加险信息</div>
      <Table :columns="additionalInsuranceColumns" :data="formData.additionalList" class="form-table" style="margin-bottom: 20px">
        <template slot-scope="{ row, index }" slot="name">
          <span>{{ row.name }}</span>
        </template>
        <template slot-scope="{ row, index }" slot="paymentPeriod">
          <span>{{ row.paymentPeriod }}</span>
          <span style="margin-left: 10px"></span>
          <lzDicTxt dicType="GUARANTEE_TYPE" :dicCode="row.paymentType"></lzDicTxt>
        </template>
        <template slot-scope="{ row, index }" slot="currencyType">
          <lzDicTxt dicType="CURRENCY_INT" :dicCode="row.currencyType"></lzDicTxt>
        </template>
        <template slot-scope="{ row, index }" slot="fee">
          <span>{{ row.fee }}</span>
        </template>
      </Table>
    </template>
    
    <validUserName ref="validUserNameRef" @success="(...params) => openEye(...params)" />
  </div>
</template>

<script>
import { common } from '@/api/mixins';
import lzDicTxt from '@/components/commons/lzDicTxt';
import lzDicSelect from '@/components/commons/lzDicSelect';
import mixinChild from '../mixin.child';
import policyStatusTxt from '@/components/commons/policyStatusTxt';
import policyStatusSelect from '@/components/commons/policyStatusSelect';
import validUserName from '@/components/commons/validUserName';
const dic = JSON.parse(localStorage.dic);
const guaranteeTypeDic = dic['GUARANTEE_TYPE'];
export default {
  mixins: [common, mixinChild],
  components: {
    lzDicSelect,
    policyStatusTxt,
    policyStatusSelect,
    validUserName,
    lzDicTxt
  },
  props: ['companyList', 'themeList', 'policyStatus', 'formData', 'disabled', 'isTransfer'],
  inject: ['parent'],
  data() {
    return {
      productList: [],
      additionalInsuranceColumns: [
        {
          title: '附加险名称',
          slot: 'name',
          align: 'center',
          minWidth: 120
        },
        {
          title: '缴费期',
          slot: 'paymentPeriod',
          align: 'center',
          minWidth: 100
        },
        {
          title: '货币种类',
          slot: 'currencyType',
          align: 'center',
          minWidth: 120
        },
        {
          title: '首年金额',
          slot: 'fee',
          align: 'center',
          minWidth: 120
        }
      ]
    };
  },
  watch: {
    'formData.guaranteeType'(newVal) {
      if (newVal == '4') {
        this.$set(this.formData, 'guaranteePeriod', '');
      }
    },
    'formData.paymentType'(newVal) {
      if (newVal == '4') {
        this.$set(this.formData, 'paymentPeriod', '');
      }
    }
  },
  computed: {
    paymentPeriodUnit() {
      return guaranteeTypeDic[this.formData.paymentType] || '';
    },
    guaranteePeriodUnit() {
      return guaranteeTypeDic[this.formData.guaranteeType] || '';
    },
    paymentPeriodRules() {
      if (this.disabled) return {};
      return {
        validator: (rule, value, callback) => {
          if (value !== '' && value !== null && value !== undefined) {
            const num = Number(value);
            if (isNaN(num) || num <= 0) {
              callback(new Error('缴费期必须为大于0的数字'));
            } else {
              callback();
            }
          } else {
            callback();
          }
        },
        trigger: 'blur'
      };
    },
    guaranteePeriodRules() {
      if (this.disabled) return {};
      return {
        validator: (rule, value, callback) => {
          if (value !== '' && value !== null && value !== undefined) {
            const num = Number(value);
            if (isNaN(num) || num <= 0) {
              callback(new Error('保障期必须为大于0的数字'));
            } else {
              callback();
            }
          } else {
            callback();
          }
        },
        trigger: 'blur'
      };
    }
  },
  // created() {},
  mounted() {
    this.companyChange();
    if (this.formData.isAdditional === undefined || this.formData.isAdditional === null || this.formData.isAdditional === '') {
      this.$set(this.formData, 'isAdditional', '0');
    }
    if (!this.formData.additionalList || !this.formData.additionalList.length) {
      this.$set(this.formData, 'additionalList', [{}]);
    }
  },
  methods: {
    onNumberInput(field) {
      let value = this.formData[field];
      const filtered = String(value)
        .replace(/[^\d]/g, '')
        .replace(/^0+(\d)/, '$1');
      const finalValue = filtered || '';
      if (finalValue !== String(value)) {
        this.$set(this.formData, field, finalValue);
      }
    },
    onChangeStatus() {
      this.$set(this.formData, 'refundDate', '');
      this.$set(this.formData, 'policySubmitDate', '');
      this.$set(this.formData, 'pendingDate', '');
      this.$set(this.formData, 'pendingHandleDate', '');
      this.$set(this.formData, 'cancelDate', '');
      this.$set(this.formData, 'underwriteTime', '');
      this.$set(this.formData, 'effectDate', '');
      this.$set(this.formData, 'expirationDate', '');
      this.$set(this.formData, 'refundDate', '');
      this.$set(this.formData, 'expireDate', '');
    },
    companyChange() {
      this.$http({
        url: '/buz/product/query/list',
        type: 'GET',
        data: { companyId: this.formData.companyId }
      }).then(res => {
        this.productList = res.data;
      });
    },
    onSelectProduct(productId) {
      const product = this.productList.find(item => item.id === productId);
      if (product) {
        this.$set(this.formData, 'productType', product.productType);
      }
    },
    // 解密
    openEye(row, code) {
      if (!row['validName' + code]) {
        this.$refs.validUserNameRef.open(row, code);
        return;
      }
      if (!row['eyeShow' + code]) {
        let operationType = {
          'policyNo': 11,
          'bankCardNo': 3
        };
        this.descrypt(
          {
            customerType: 1,
            query: row.id,
            operationFunction: 3,
            operationType: operationType[code]
          },
          row,
          code
        ).then(() => {
          this.$set(row, 'eyeShow' + code, true);
        });
      }
    }
  }
};
</script>
<style scoped lang="scss">
.form-table {
  /deep/.ivu-table-cell {
    margin: 10px 0;
  }
}
</style>
